




import { Vue, Component, Prop } from 'vue-property-decorator'
import store from 'src/assets/store'
import SessionDurationFormat from 'components/presenter/item/session/SessionDurationFormat.vue'
import { Session, SessionAttendee } from 'src/graphql/types'

@Component({
  components: {
    SessionDurationFormat
  }
})
export default class SessionDuration extends Vue {

  @Prop()
  readonly session!: Session

  @Prop()
  readonly attendee!: SessionAttendee

  get serverTime () {
    return store.now()
  }

  get miliseconds () {
    let miliseconds
    if (this.attendee && this.session) {
      const attendeeBeginning = this.attendee.startedAt || this.attendee.createdAt
      if (this.attendee.finishedAt) {
        miliseconds = new Date(this.attendee.finishedAt).getTime() - new Date(attendeeBeginning).getTime()
      } else if (this.session.stoppedAt && new Date(this.session.stoppedAt) < this.serverTime) {
        miliseconds = new Date(this.session.stoppedAt).getTime() - new Date(attendeeBeginning).getTime()
      } else {
        miliseconds = this.serverTime.getTime() - new Date(attendeeBeginning).getTime()
      }
    }
    return miliseconds
  }
}
